module.exports = __webpack_public_path__ + "img/mb_bg.9cc82e5.webp";